import React, { useEffect, useState,useRef, memo } from 'react';
import PropTypes from "prop-types";
import { Outlet } from 'react-router-dom';

//import Components
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import RightSidebar from '../Components/Common/RightSidebar';

//import actions
import {
    changeLayout,
    changeSidebarTheme,
    changeLayoutMode,
    changeLayoutWidth,
    changeLayoutPosition,
    changeTopbarTheme,
    changeLeftsidebarSizeType,
    changeLeftsidebarViewType,
    changeSidebarImageType,
    changeSidebarVisibility,
    changeLayoutTheme,
    changeLayoutThemeColor,
    
} from "../slices/thunks";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';
import { initializeSocketConnection, disconnectSocket, subscribeToOpenOrders ,handleSocketData,subscribeNotifications } from "../slices/socket/socketThunks";
import { setConnectionStatus } from "../slices/socket/socketSlice";
import webSocketService from "../services/socketService";

import { handleNotification, fetchNotificationSummaryThunk } from "../slices/socket/notificationThunks";
import { toast } from 'react-toastify';
import ReadOnlyMode from '../Components/Common/ReadOnlyMode';

// Debounce helper
const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
            func(...args);
        }, delay);
    };
};

const Layout = (props) => {
    const [headerClass, setHeaderClass] = useState("");
    const notificationAudio = useRef(new Audio("/notification2.mp3"));
    const dispatch = useDispatch();

    const selectLayoutState = (state) => state.Layout;
    const selectLayoutProperties = createSelector(
        selectLayoutState,
        (layout) => ({
            layoutType: layout.layoutType,
            layoutThemeType : layout.layoutThemeType,
            layoutThemeColorType: layout.layoutThemeColorType,
            leftSidebarType: layout.leftSidebarType,
            layoutModeType: layout.layoutModeType,
            layoutWidthType: layout.layoutWidthType,
            layoutPositionType: layout.layoutPositionType,
            topbarThemeType: layout.topbarThemeType,
            leftsidbarSizeType: layout.leftsidbarSizeType,
            leftSidebarViewType: layout.leftSidebarViewType,
            leftSidebarImageType: layout.leftSidebarImageType,
            preloader: layout.preloader,
            sidebarVisibilitytype: layout.sidebarVisibilitytype,
        })
    );
    // Inside your component
    const {
        layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        preloader,
        sidebarVisibilitytype,
        layoutThemeType,
        layoutThemeColorType
    } = useSelector(selectLayoutProperties);
    
    useEffect(() => {
        const unlockAudio = () => {
            const audio = notificationAudio.current;

            audio.play()
                .then(() => {
                    audio.pause();
                    audio.currentTime = 0;
                    console.log("Audio unlocked");
                })
                .catch(() => {});

            document.removeEventListener("click", unlockAudio);
            document.removeEventListener("keydown", unlockAudio);
        };

        document.addEventListener("click", unlockAudio);
        document.addEventListener("keydown", unlockAudio);

        return () => {
            document.removeEventListener("click", unlockAudio);
            document.removeEventListener("keydown", unlockAudio);
        };
    }, []);
/*
    layout settings
    */
    useEffect(() => {
        if (
            layoutType ||
            leftSidebarType ||
            layoutModeType ||
            layoutWidthType ||
            layoutPositionType ||
            topbarThemeType ||
            leftsidbarSizeType ||
            leftSidebarViewType ||
            leftSidebarImageType ||
            sidebarVisibilitytype ||
            layoutThemeType ||
            layoutThemeColorType
        ) {
            window.dispatchEvent(new Event('resize'));
            dispatch(changeLeftsidebarViewType(leftSidebarViewType));
            dispatch(changeLeftsidebarSizeType(leftsidbarSizeType));
            dispatch(changeSidebarTheme(leftSidebarType));
            dispatch(changeLayoutThemeColor(layoutThemeColorType));
            dispatch(changeLayoutTheme(layoutThemeType));
            dispatch(changeLayoutMode(layoutModeType));
            dispatch(changeLayoutWidth(layoutWidthType));
            dispatch(changeLayoutPosition(layoutPositionType));
            dispatch(changeTopbarTheme(topbarThemeType));
            dispatch(changeLayout(layoutType));
            dispatch(changeSidebarImageType(leftSidebarImageType));
            dispatch(changeSidebarVisibility(sidebarVisibilitytype));
        }
    }, [layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        layoutThemeType,
        layoutThemeColorType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        sidebarVisibilitytype,
        dispatch]);
    /*
    call dark/light mode
    */
    const onChangeLayoutMode = (value) => {
        if (changeLayoutMode) {
            dispatch(changeLayoutMode(value));
        }
    };

    // class add remove in header 
    useEffect(() => {
        window.addEventListener("scroll", scrollNavigation, true);
        return () => {
            window.removeEventListener("scroll", scrollNavigation, true);
        };
    }, []);

    useEffect(() => {
    if ("Notification" in window && Notification.permission === "default") {
        Notification.requestPermission();
    }
    }, []);

    function scrollNavigation() {
        var scrollup = document.documentElement.scrollTop;
        if (scrollup > 50) {
            setHeaderClass("topbar-shadow");
        } else {
            setHeaderClass("");
        }
    }

    useEffect(() => {
        if (sidebarVisibilitytype === 'show' || layoutType === "vertical" || layoutType === "twocolumn") {
            document.querySelector(".hamburger-icon").classList.remove('open');
        } else {
            document.querySelector(".hamburger-icon") && document.querySelector(".hamburger-icon").classList.add('open');
        }
    }, [sidebarVisibilitytype, layoutType]);

    // Get socket state from Redux
    const socketState = useSelector((state) => state.Socket);
    const totalNotifications = useSelector(
    (state) => state.Notification?.summary?.total || 0
    );

    // Initialize socket connection
    useEffect(() => {
        const initializeSocket = async () => {
            try {
                const authUser = localStorage.getItem('authUser');
                if (authUser) {
                    const parsedAuth = JSON.parse(authUser);
                    const token = parsedAuth?.user?._id || parsedAuth?.user?.id;
                    if (token) {
                        await dispatch(initializeSocketConnection(token));
                        await dispatch(subscribeNotifications());
                    }
                }
            } catch (error) {
                console.error('Socket initialization error:', error);
            }
        };

        initializeSocket();

        return () => {
            dispatch(disconnectSocket());
        };
    }, [dispatch]);


    // Debounced fetch summary to throttle rapid events
    const debouncedFetchSummary = React.useRef(
        debounce(() => {
            dispatch(fetchNotificationSummaryThunk());
        }, 1000)
    ).current;

    useEffect(() => {
        const handleMessage = (event) => {
            try {
                const data = JSON.parse(event.data);

                if (data.topic === "adminNotification" || data.type === "notification") {
                    // Extract title and message text safely
                    const notificationDetails = data.message || data;
                    const title = notificationDetails.title || "Notification Received";
                    const msgText = notificationDetails.message || "A new update has been received.";

                    if ("Notification" in window && Notification.permission === "granted") {
                    new Notification(title, {
                        body: msgText,
                        icon: "/logo-sm.png"
                    });
                }

                    // Show toast notification
                    toast.info(
                        <div>
                            <strong>{title}</strong>
                            <div>{msgText}</div>
                        </div>,
                        { autoClose: 5000 }
                    );

                    // Play dummy notification sound
                    // try {
                    //     const audio = new Audio("/notification.mp3");
                    //     audio.play().catch(err => {
                    //         console.warn("Audio play blocked or dummy audio file not found:", err.message);
                    //     });
                    // } catch (e) {
                    //     console.warn("Failed to play audio:", e);
                    // }

                    // Play notification sound
                    try {
                        notificationAudio.current.currentTime = 0;
                        notificationAudio.current.play().catch(err => {
                            console.warn("Audio play failed:", err.message);
                        });
                    } catch (e) {
                        console.warn("Failed to play audio:", e);
                    }

                    // Dispatch handleNotification action (keep Redux history)
                    dispatch(handleNotification(data));

                    // Trigger debounced summary refresh
                    debouncedFetchSummary();
                } else {
                    switch (data.topic) {
                        case "runningPositions":
                            dispatch(handleSocketData(data));
                            break;
                        case "getAllOpenOrders":
                            // Handled locally by BookManagement page — no action needed here
                            break;
                        default:
                            console.warn("Unknown socket topic:", data.topic);
                    }
                }
            } catch (err) {
                console.error(err);
            }
        };

        webSocketService.addListener('layout', handleMessage);

        return () => {
            webSocketService.removeListener('layout');
        };
    }, [dispatch, debouncedFetchSummary]);

    // Monitor socket connection and handle re-subscription after reconnect
    useEffect(() => {
        const checkConnection = () => {
            const isConnected = webSocketService.isSocketConnected();
            const { connectionStatus, subscriptions } = socketState;
            const runningPositions = subscriptions.runningPositions;

            // Update connection status if it doesn't match actual socket state
            if (isConnected && connectionStatus !== 'connected') {
                dispatch(setConnectionStatus('connected'));
                
                // Auto-refresh summary counts on reconnect
                dispatch(fetchNotificationSummaryThunk());
                
                // Auto re-subscribe if there's an active subscription
                if (runningPositions.accountNumber) {
                    dispatch(
                        subscribeToOpenOrders({
                            accountNumber: runningPositions.accountNumber,
                            planId: runningPositions.planId,
                        })
                    );
                }
            } else if (!isConnected && connectionStatus === 'connected') {
                // Socket disconnected
                dispatch(setConnectionStatus('disconnected'));
            }
        };

        // Check connection status periodically
        const checkConnectionInterval = setInterval(checkConnection, 2000);

        return () => {
            clearInterval(checkConnectionInterval);
        };
    }, [dispatch, socketState]);

    useEffect(() => {
    const defaultTitle = "Mynt Capital | CRM"; // Change this to your app name

    if (totalNotifications > 0) {
        document.title = `(${totalNotifications}) ${defaultTitle}`;
    } else {
        document.title = defaultTitle;
    }
}, [totalNotifications]);

    return (
        <React.Fragment>
            <div id="layout-wrapper">
                <Header
                    headerClass={headerClass}
                    layoutModeType={layoutModeType}
                    onChangeLayoutMode={onChangeLayoutMode} />
                <Sidebar
                    layoutType={layoutType}
                />
                <div className="main-content">
                    <ReadOnlyMode />
                    <Outlet />
                    <Footer />
                </div>
            </div>
            <RightSidebar />
        </React.Fragment>

    );
};

Layout.propTypes = {
    children: PropTypes.object,
};

// Memoize the Layout component to prevent unnecessary re-renders
// Layout will still re-render when Redux state changes (expected behavior)
// but will not unmount/remount on route changes
const MemoizedLayout = memo(Layout);

export default MemoizedLayout;